import { useCallback } from 'react';
import {
  useCryptoRateStore,
  useIsCryptoRatesLoaded
} from '../../store/cryptoRate';

export const useFiatExchange = () => {
  const { cryptoRate = {} } = useCryptoRateStore();
  const isRatesLoaded = useIsCryptoRatesLoaded();

  const convertToFiat = useCallback(
    (amount, currency) => {
      let result = 0;
      if (amount && isRatesLoaded) {
        result = Math.floor((amount / cryptoRate[currency]) * 100) / 100;
      }

      return result;
    },
    [cryptoRate, isRatesLoaded]
  );

  return {
    convertToFiat
  };
};
